<template>
  <div class="dropdown" v-if="showDropdown && dropdownPosition"
    :style="{ top: dropdownPosition.top + 'px', left: dropdownPosition.left + 'px' }">
    <ul>
      <li v-for="item in dropdownItems || []" :key="item.key" @click.stop="selectSortItem(item)">
        {{ item.value }}
      </li>
    </ul>
  </div>
  <div class="table-wrapper">
    <table class="list-table">
      <thead>
        <tr>
          <th :class="{active : col.sortable}" v-for="col in columns" :key="col.field" @click="col.sortable ? toggleDropdown(col.field, $event) : null">
            {{ col.title }}
            <span v-if="col.sortable">{{ openDropdownField === col.field ? '▲' : '▼' }}</span>
          </th>
        </tr>
      </thead>
      <tbody v-if="data.length > 0">
        <tr v-for="(row, rowIndex) in data" :key="row.id || rowIndex">
          <td v-for="col in columns" :key="col.field">
            <span v-html="getCellContent(col, row, rowIndex)"></span>
          </td>
        </tr>
      </tbody>
    </table>
    <NodataView v-if="data.length === 0" height="200px" />
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, onMounted, onBeforeUnmount } from 'vue'
import NodataView from '../noData/NodataView.vue'
import { formatNumberWithComma } from '@/utils/order'

const props = defineProps({
  columns: Array,
  data: Array
})

const emit = defineEmits(['sortItemSelected'])
const showDropdown = ref(false)
const dropdownItems = ref([])
const dropdownPosition = ref(null)

const openDropdownField = ref(null)

const toggleDropdown = (field) => {
  const rect = event.target.getBoundingClientRect()
  dropdownItems.value = props.columns.find(c => c.field === field)?.sortItems || []
  dropdownPosition.value = {
    top: rect.bottom + window.scrollY,
    left: rect.left + window.scrollX,
  }
  showDropdown.value = openDropdownField.value === field ? false : true
  openDropdownField.value = showDropdown.value ? field : null
}

const selectSortItem = (item) => {
  openDropdownField.value = null
  showDropdown.value = false;
  emit('sortItemSelected', item)
}
const isDateLikeString = (str) => {
  return typeof str === 'string' && /^\d{4}-\d{2}-\d{2}/.test(str);
};
const getCellContent = (col, row, rowIndex) => {
  if (col.formatter && typeof col.formatter === 'function') {
    return col.formatter(row, rowIndex, emit)
  }
  if(!isNaN(parseFloat(row[col.field])) && !isDateLikeString(row[col.field])) return formatNumberWithComma(row[col.field]);
  return row[col.field]
}
const handleClickOutside = (e) => {
    const isPopup = e.target.closest('.dropdown');
    const isInput = e.target.closest('th.active');
    if (!isPopup && !isInput){ 
      showDropdown.value = false;
      openDropdownField.value= null;
    }
};
onMounted(() => document.addEventListener('click', handleClickOutside));
onBeforeUnmount(() => document.removeEventListener('click', handleClickOutside));
</script>

<style lang="scss" scoped>
@use  "@/assets/scss/components/common/list.scss" as list;
</style>